import { Chip, Tooltip } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

const FILTER_SCOPE_BASIS_LABEL = "Standalone · vs full benchmark"
const FILTER_SCOPE_BASIS_TOOLTIP = "Filters apply to the portfolio only; the benchmark is unfiltered."
const FILTER_SCOPE_BASIS_GROSS_EXPOSURE_NOTE = "On a long/short portfolio, the slice's returns are on its gross exposure."

const FILTER_SCOPE_BASIS_CHIP_SX = { mx: 0.75, alignSelf: "center" } satisfies SxProps<Theme>

interface FilterScopeBasisChipProps {
  showGrossExposureNote?: boolean
}

export default function FilterScopeBasisChip({ showGrossExposureNote = true }: FilterScopeBasisChipProps) {
  const tooltip = showGrossExposureNote ? `${FILTER_SCOPE_BASIS_TOOLTIP} ${FILTER_SCOPE_BASIS_GROSS_EXPOSURE_NOTE}` : FILTER_SCOPE_BASIS_TOOLTIP
  return (
    <Tooltip title={tooltip}>
      <Chip size="small" label={FILTER_SCOPE_BASIS_LABEL} sx={FILTER_SCOPE_BASIS_CHIP_SX} data-test-id="filter-scope-basis-chip" />
    </Tooltip>
  )
}
